import axios from '../utils/axios';

export default function fetchClientNotes(adminId, ceId, params) {
    return (
        axios.get('/admin/' + adminId + '/client-engagement/notes/' + ceId, { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
